import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';

export const loginGuard: CanActivateFn = (route, state) => {
  const _Router = inject(Router);

  // Logic to verify token here
  const token = localStorage.getItem('token');
  if (token) {
    _Router.navigate(['/']);
    return false;
  } else {
    return true;
  }
};
